import React from "react";
import { fetchSubscribeToPet, fetchSubscribeNotifications } from "../../../actions/subscribeToPet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AvatarEditor from "react-avatar-editor";
import history from "../../../history.js";
import moment from "moment";
import { Loader } from "../../../components/loader";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import "react-select/dist/react-select.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, { textFilter, selectFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { BreadCrumb } from "../../../components/breadcrumb";
import Responsive from "react-responsive";
import config from "../../../config";
import _ from "lodash";
import Store from "../../../store";

const $ = window.$;
const { SearchBar } = Search;

const petAvailabilityStatus = {
  available: "available",
  sold: "sold",
};

const orientation = window.matchMedia("(max-width: 700px)").matches ? "vertical" : "horizontal";

const userPermissionList = {
  listSocialMediaSubmission : 'list-social-media-submission',
};

class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    subscribeNotification: [],
    listSocialMediaSubmissionFlag:[],
  };

  tableHeaderColumnData = [
    {
      dataField: "SubscribeToPet.mobileNo",
      text: "Mobile No",
      sort: true,
    },
    {
      dataField: "message",
      text: "Message",
      sort: true,
      formatter: (cell) => cell
    },
    {
      dataField: "response",
      text: "Response",
      sort: true,
      formatter: (cell) => cell,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cell, row) => {
        return (
          <div>
            {cell === "Sent" ? 
                <span class="m-badge m-badge--success mx-auto my-0 px-4">{cell}</span>
            : ""    
            }

            {cell === "Waiting" ? 
                <span class="m-badge m-badge--warning mx-auto my-0 px-4">{cell}</span>
            : ""    
            }

            {cell === "In-Progress" ? 
                <span class="m-badge m-badge--primary mx-auto my-0 px-4">{cell}</span>
            : ""    
            }

            {cell === "Failed" ? 
                <span class="m-badge m-badge--danger mx-auto my-0 px-4">{cell}</span>
            : ""    
            }

            {cell === "Retry" ? 
                <span class="m-badge m-badge--info mx-auto my-0 px-4">{cell}</span>
            : ""    
            }
          </div>
        );
      }  
    }
  ];

  componentDidMount() {
    this.props.fetchSubscribeNotifications();
    this.loadPermissions();
  }

  loadPermissions(){  
    let allPermission = JSON.parse( localStorage.getItem('userPermissions')) ; 
      if(allPermission && allPermission.length > 0){ 
          const listSocialMediaSubmission =  allPermission.find(item => item.Module.module_name == userPermissionList.listSocialMediaSubmission);            
          this.setState({ listSocialMediaSubmissionFlag: listSocialMediaSubmission ? listSocialMediaSubmission.value : true,});
      }
    
  }

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.data.subscribeToPetReducer.subscribeNotifications !==
      this.props.data.subscribeToPetReducer.subscribeNotifications
    ) {
      let subscribeNotification = nextProps.data.subscribeToPetReducer.subscribeNotifications;

      this.setState({
        subscribeNotification: subscribeNotification,
        loadingBd: false,
      });
    }
  };

  async componentDidUpdate(prevProps, prevState) {}

  items = [{ title: "Subscribe Notifiations", to: "/subscribe-messages" }];

  render() {
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head medical-record-head-btn-set">
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Subscribe Notifications
                        <small>List of all the sent notification to subscribers</small>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="m-portlet__body medical-record-content subscribe-to-pet-table">
                <ul
                    className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn"
                    role="tablist"
                  >
                    <li className="nav-item m-tabs__item">
                      <NavLink
                          className={classnames({
                            "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                            active: false
                          })}
                          to={`/subscribe-to-pets/mobileNo`}
                      >
                        Mobile No
                      </NavLink>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <NavLink
                          className={classnames({
                            "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                            active: false
                          })}
                          to={`/subscribe-to-pets/pet`}
                      >
                        Pet
                      </NavLink>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <NavLink
                          className={classnames({
                            "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                            active: false
                          })}
                          to={`/subscribe-messages`}
                      >
                        Notification Status
                      </NavLink>
                    </li>
                  </ul>
                  <div className="tab-content">
                    
                    <ToolkitProvider
                      keyField="id"
                      data={this.state.subscribeNotification}
                      columns={this.tableHeaderColumnData}
                      search
                      hover={true}
                      filter={filterFactory()}
                    >
                      {(props) => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon m--align-right">
                              <i className="fas fa-search mt-1"></i>
                              <SearchBar {...props.searchProps} />
                          </div>
                        </div>
                          <div className="mb-2">
                            <small className="small-text">
                              *If you experience any difficulty in viewing the medical record, please make sure your
                              cache is cleared and completed a hard refresh. IOS users might have to use a private
                              window.
                            </small>
                          </div>
                          <BootstrapTable classes="petTable" {...props.baseProps} pagination={paginationFactory()} />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const Mobile = (props) => <Responsive {...props} maxWidth={767} />;
export const Default = (props) => <Responsive {...props} minWidth={768} />;

const mapStateToProps = (state) => ({
  data: state,
});

const mapDispatchToProps = (dispatch) => ({
    fetchSubscribeNotifications: () => {
    dispatch(fetchSubscribeNotifications());
  },
});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);
